import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import {jsonInit} from './client';
import {useAuth} from '../hooks/useAuth';
import {ApiToken, ConnectedApp} from '../types';

const tokensKey = ['tokens'] as const;
const appsKey = ['connected-apps'] as const;

export function useTokens() {
    const {call} = useAuth();
    return useQuery({queryKey: tokensKey, queryFn: () => call<{items: ApiToken[]}>('/api/tokens').then(r => r.items)});
}

/** Create (the response carries the token, shown once) and revoke. */
export function useTokenMutations() {
    const {call} = useAuth();
    const queryClient = useQueryClient();
    const refresh = () => queryClient.invalidateQueries({queryKey: tokensKey});

    const create = useMutation({
        mutationFn: (name: string) => call<{token: string; item: ApiToken}>('/api/tokens', jsonInit('POST', {name})),
        onSuccess: refresh,
        meta: {silent: true}
    });
    const revoke = useMutation({
        mutationFn: (id: string) => call<void>(`/api/tokens/${id}`, {method: 'DELETE'}),
        onSuccess: refresh
    });
    return {create, revoke};
}

export function useConnectedApps() {
    const {call} = useAuth();
    return useQuery({queryKey: appsKey, queryFn: () => call<{items: ConnectedApp[]}>('/api/oauth/grants').then(r => r.items)});
}

export function useDisconnectApp() {
    const {call} = useAuth();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id: string) => call<void>(`/api/oauth/grants/${id}`, {method: 'DELETE'}),
        onSuccess: () => queryClient.invalidateQueries({queryKey: appsKey})
    });
}
